import * as yup from 'yup'

export const accountCreationSchema = yup.object({
  create_account: yup.boolean().default(false).required(),
})
